/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnumerationEvaluationResultDto } from './EnumerationEvaluationResultDto';
import {
    instanceOfEnumerationEvaluationResultDto,
    EnumerationEvaluationResultDtoFromJSON,
    EnumerationEvaluationResultDtoFromJSONTyped,
    EnumerationEvaluationResultDtoToJSON,
} from './EnumerationEvaluationResultDto';
import type { NumericEvaluationResultDto } from './NumericEvaluationResultDto';
import {
    instanceOfNumericEvaluationResultDto,
    NumericEvaluationResultDtoFromJSON,
    NumericEvaluationResultDtoFromJSONTyped,
    NumericEvaluationResultDtoToJSON,
} from './NumericEvaluationResultDto';

/**
 * @type EvaluationResultDto
 * 
 * @export
 */
export type EvaluationResultDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.EnumerationEvaluationResultDto, Ptw.Ptw100.AppZero.Application.Shared' } & EnumerationEvaluationResultDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.NumericEvaluationResultDto, Ptw.Ptw100.AppZero.Application.Shared' } & NumericEvaluationResultDto;


export function EvaluationResultDtoFromJSON(json: any): EvaluationResultDto {
    return EvaluationResultDtoFromJSONTyped(json, false);
}

export function EvaluationResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.EnumerationEvaluationResultDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...EnumerationEvaluationResultDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.EnumerationEvaluationResultDto, Ptw.Ptw100.AppZero.Application.Shared'};
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.NumericEvaluationResultDto, Ptw.Ptw100.AppZero.Application.Shared':
            return {...NumericEvaluationResultDtoFromJSONTyped(json, true), $type: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.NumericEvaluationResultDto, Ptw.Ptw100.AppZero.Application.Shared'};
        default:
            throw new Error(`No variant of EvaluationResultDto exists with '$type=${json['$type']}'`);
    }
}

export function EvaluationResultDtoToJSON(value?: EvaluationResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.EnumerationEvaluationResultDto, Ptw.Ptw100.AppZero.Application.Shared':
            return EnumerationEvaluationResultDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.NumericEvaluationResultDto, Ptw.Ptw100.AppZero.Application.Shared':
            return NumericEvaluationResultDtoToJSON(value);
        default:
            throw new Error(`No variant of EvaluationResultDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the EvaluationResultDto interface.
 */
export function instanceOfEvaluationResultDto(value: any): value is EvaluationResultDto {
    if (instanceOfEnumerationEvaluationResultDto(value)) return true;
    if (instanceOfNumericEvaluationResultDto(value)) return true;
    return false;
}

